import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const AuthError = styled.div`
  padding-left: 45px;
  padding-right: 45px;
  margin-top: 16px;
  font-size: 12px;
  color: ${COLORS.error};
  text-align: center;
`;

export default AuthError;
